import { render, staticRenderFns } from "./ZKDoor.vue?vue&type=template&id=24518d8e&scoped=true&"
import script from "./ZKDoor.vue?vue&type=script&lang=js&"
export * from "./ZKDoor.vue?vue&type=script&lang=js&"
import style0 from "./ZKDoor.vue?vue&type=style&index=0&id=24518d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24518d8e",
  null
  
)

export default component.exports